import {
  BoardTemplateBackgroundDecoration,
  BoardTemplateLabelTitle,
  BoardTemplateScheduleTable,
} from "./board";
import { SimpleTemplateLabelTitle, SimpleTemplateScheduleTable } from "./simple";
import { TemplateDefinition } from "./types";
import {
  WaveHoleTemplateBackgroundDecoration,
  WaveHoleTemplateLabelTitle,
  WaveHoleTemplateScheduleTable,
} from "./wave-hole";

export * from "./types";

export const TEMPLATES: TemplateDefinition[] = [
  {
    id: "wave-hole",
    name: "ウェーブホール",
    themes: [
      {
        id: "wave-hole-aqua-sunset",
        name: "ラムネ",
        base: "22 47 86",
        accent: "140 140 153",
        light: "255 247 242",
        back: "104 181 218",
      },
      {
        id: "wave-hole-rose-night",
        name: "トマト",
        base: "168 12 27",
        accent: "112 77 82",
        light: "255 254 217",
        back: "246 98 101",
      },
      {
        id: "wave-hole-cobalt-lime",
        name: "みかん",
        base: "49 124 0",
        accent: "103 127 88",
        light: "255 242 202",
        back: "249 166 33",
      },
      {
        id: "wave-hole-mint-gold",
        name: "レタス",
        base: "22 78 75",
        accent: "116 132 132",
        light: "241 255 204",
        back: "119 207 190",
      },
    ],
    BackgroundDecoration: WaveHoleTemplateBackgroundDecoration,
    LabelTitle: WaveHoleTemplateLabelTitle,
    ScheduleTable: WaveHoleTemplateScheduleTable,
  },
  {
    id: "board",
    name: "ボード",
    // 背景画像に表組みが焼き込まれているため、テーマは色だけでなく背景画像も切り替える。
    // base = 文字色 / accent = 休みの色（曜日の「日」と同色）/ light = ボード面 / back = 外枠
    themes: [
      {
        id: "board-blackboard",
        name: "黒板",
        base: "255 255 255",
        accent: "205 100 111",
        light: "53 88 64",
        back: "170 123 17",
      },
      {
        id: "board-whiteboard",
        name: "ホワイトボード",
        base: "0 0 0",
        accent: "239 58 58",
        light: "255 255 255",
        back: "195 199 209",
      },
    ],
    BackgroundDecoration: BoardTemplateBackgroundDecoration,
    LabelTitle: BoardTemplateLabelTitle,
    ScheduleTable: BoardTemplateScheduleTable,
  },
  {
    id: "simple",
    name: "シンプル",
    themes: [
      {
        id: "navy-red",
        name: "ネイビー x レッド",
        base: "42 42 114",
        accent: "255 0 0",
        light: "255 255 255",
        back: "162 162 186",
      },
      {
        id: "midnight-yellow",
        name: "ミッドナイト x イエロー",
        base: "16 42 67",
        accent: "249 249 50",
        light: "255 255 255",
        back: "130 154 177",
      },
      {
        id: "forest-lime",
        name: "フォレスト x ライム",
        base: "31 61 43",
        accent: "195 255 31",
        light: "248 250 252",
        back: "105 214 170",
      },
      {
        id: "grape-pink",
        name: "グレープ × ピンク",
        base: "70 53 132",
        accent: "237 255 0",
        light: "255 247 251",
        back: "242 158 190",
      },
    ],
    LabelTitle: SimpleTemplateLabelTitle,
    ScheduleTable: SimpleTemplateScheduleTable,
  }
];

export const DEFAULT_TEMPLATE = TEMPLATES[0];
export const DEFAULT_THEME = DEFAULT_TEMPLATE.themes[0];

export const getTemplateById = (templateId?: string) =>
  TEMPLATES.find((template) => template.id === templateId) ?? DEFAULT_TEMPLATE;

export const findTemplateByThemeId = (themeId?: string) =>
  TEMPLATES.find((template) => template.themes.some((theme) => theme.id === themeId)) ?? null;

export const getThemeById = (templateId: string, themeId?: string) => {
  const template = getTemplateById(templateId);
  return template.themes.find((theme) => theme.id === themeId) ?? template.themes[0];
};

export const getDefaultThemeIdForTemplate = (templateId: string) => getTemplateById(templateId).themes[0].id;

export const resolveTemplateThemeSelection = ({
  templateId,
  themeId,
}: {
  templateId?: string;
  themeId?: string;
}) => {
  const inferredTemplate = !templateId ? findTemplateByThemeId(themeId) : null;
  const template = getTemplateById(templateId ?? inferredTemplate?.id);
  const theme = getThemeById(template.id, themeId);

  return {
    template,
    theme,
    templateId: template.id,
    themeId: theme.id,
  };
};
